export default () => ({
  supportSettings: []
});
